import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getMOONToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.MOON,
    symbol: 'MOON',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('MOON'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/moon.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="MOON"
        {...props}
      />
    ),
  };
};
